import {
  faChevronLeft,
  faChevronRight,
  faCloudArrowUp,
  faCrown,
  faInfoCircle,
  faSpinner,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { useLanguage } from "../../contexts/LanguageContext";
import PhotoContextMenu from "../PhotoContextMenu/PhotoContextMenu";

const DashboardPhotos = ({
  photos,
  selectedPhotos,
  setSelectedPhotos,
  handlePhotoSelect,
  handleDownloadSelected,
  handleDeletePhoto,
  handlePhotoView,
  handlePhotoClick,
  user,
  currentPage,
  totalPages,
  totalPhotos,
  onPageChange,
  photosPerPage,
  isLoadingMore,
  eventName,
  setIsPricingModalOpen,
}) => {
  const { t } = useLanguage();
  const PHOTOS_PER_PAGE = 30;

  const renderPagination = () => {
    if (totalPages <= 1) return null;

    const getPageNumbers = () => {
      const pages = [];
      const maxVisiblePages = 5;

      if (totalPages <= maxVisiblePages) {
        for (let i = 1; i <= totalPages; i++) {
          pages.push(i);
        }
      } else {
        const startPage = Math.max(1, currentPage - 2);
        const endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

        if (startPage > 1) {
          pages.push(1);
          if (startPage > 2) pages.push("...");
        }

        for (let i = startPage; i <= endPage; i++) {
          pages.push(i);
        }

        if (endPage < totalPages) {
          if (endPage < totalPages - 1) pages.push("...");
          pages.push(totalPages);
        }
      }

      return pages;
    };

    const pageNumbers = getPageNumbers();
    const startItem = (currentPage - 1) * photosPerPage + 1;
    const endItem = Math.min(currentPage * photosPerPage, totalPhotos);

    return (
      <div className="pagination-container">
        <div className="pagination-info">
          <span>
            Showing {startItem}-{endItem} of {totalPhotos} photos
          </span>
        </div>

        <div className="pagination">
          <button
            className="pagination-btn"
            onClick={() => onPageChange(currentPage - 1)}
            disabled={currentPage === 1}
          >
            <FontAwesomeIcon icon={faChevronLeft} />
          </button>

          {pageNumbers.map((page, index) => (
            <button
              key={index}
              className={`pagination-btn ${
                page === currentPage ? "active" : ""
              } ${page === "..." ? "dots" : ""}`}
              onClick={() => page !== "..." && onPageChange(page)}
              disabled={page === "..."}
            >
              {page}
            </button>
          ))}

          <button
            className="pagination-btn"
            onClick={() => onPageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            <FontAwesomeIcon icon={faChevronRight} />
          </button>
        </div>
      </div>
    );
  };

  return (
    <>
      <div
        className={`photos-container grid ${user?.isPremium ? "" : "m-top"}`}
      >
        {photos.map((photo, index) => (
          <div key={photo.id} className="photo-item">
            <div className="photo-card">
              {user?.isPremium && (
                <div className="photo-selection">
                  <input
                    type="checkbox"
                    checked={selectedPhotos.has(photo.id)}
                    onChange={() =>
                      handlePhotoSelect({
                        photoId: photo.id,
                        selectedPhotos,
                        setSelectedPhotos,
                      })
                    }
                    className="photo-checkbox"
                  />
                </div>
              )}
              <span className="uploaded_by">
                <FontAwesomeIcon icon={faCloudArrowUp} />{" "}
                {user?.isPremium ? photo.uploaded_by : "Anonymous"}
              </span>

              {/* Menú contextual */}
              <PhotoContextMenu
                photo={photo}
                onDownload={() =>
                  handleDownloadSelected({
                    selectedPhotos: new Set([photo.id]),
                    photos: [photo],
                    eventName,
                  })
                }
                onDelete={() => handleDeletePhoto(photo.id)}
                onView={handlePhotoView}
                user={user}
              />

              <div
                className="photo-image"
                onClick={() => handlePhotoClick(photo, index)}
              >
                <img src={photo.url} alt={`${photo.id}`} />
                <div className="photo-overlay"></div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Pagination */}
      {user?.isPremium && renderPagination()}

      {!user?.isPremium && totalPhotos > PHOTOS_PER_PAGE && (
        <div className="premium-alert premium-alert--warning">
          <div className="premium-alert__icon">
            <FontAwesomeIcon icon={faInfoCircle} color="white" />
          </div>
          <div className="premium-alert__content">
            <div className="premium-alert__title" style={{ color: "white" }}>
              {t("dashboard.upload.uploadMessageSmall")}
              {totalPhotos}
              {t("dashboard.upload.uploadMessage")}
            </div>
            <div
              className="premium-alert__message"
              style={{ color: "white", fontSize: "0.9rem" }}
            >
              {t("dashboard.upload.uploadMessage2")}
            </div>
            <button
              className="btn-pro"
              onClick={() => setIsPricingModalOpen(true)}
            >
              <FontAwesomeIcon
                icon={faCrown}
                style={{ color: "#9aa0ad", marginRight: "5px" }}
              />
              {t("header.upgrade")}
            </button>
          </div>
        </div>
      )}

      {/* Loading indicator for infinite scroll */}
      {isLoadingMore && (
        <div className="infinite-scroll-loading">
          <FontAwesomeIcon icon={faSpinner} spin />
          <span>Loading more photos...</span>
        </div>
      )}
    </>
  );
};

export default DashboardPhotos;
